import React from "react";
import Chat from "./chat";
import { Container, Accordion } from "react-bootstrap";
import './FAQ.css';
import './Global.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const FAQ = () => {
    return (
        <div class="faq text-center">
            <div class="title-padding top-header ">
                <h1>Frequently asked questions</h1>
            </div>
            <div>
                {/* <Chat /> */}
            </div>
            <Container>
            <Accordion className="accordion-flush info">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>What is the dress code? </Accordion.Header>
                        <Accordion.Body>
                        The dress code is formal/traditional attire.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>What time should I arrive for the ceremony?</Accordion.Header>
                        <Accordion.Body>
                        The ceremony will begin promptly at 1:30 PM. Please arrive by 1:00 PM to ensure you have ample time to find your seat and settle in.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Is the ceremony indoors or outdoors?</Accordion.Header>
                        <Accordion.Body>
                        The ceremony will be held indoors
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Will there be parking available?  If so, is there a cost?</Accordion.Header>
                        <Accordion.Body>
                        There will be parking available on site. Parking is complimentary for all guests.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Are children welcome at the ceremony and/or reception?</Accordion.Header>
                        <Accordion.Body>
                        We respectfully request that only adults attend the ceremony and reception. We hope you understand our decision to keep the event adults-only.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>Will there be a dance floor?</Accordion.Header>
                        <Accordion.Body>
                        Yes, there will be a dance floor for guests to enjoy during the reception. Get ready to dance the night away.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>What time will the reception end?</Accordion.Header>
                        <Accordion.Body>
                        The reception will conclude at 12:00 AM. We hope you can join us for the entire evening of celebration!
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7">
                        <Accordion.Header>Is there a gift registry?</Accordion.Header>
                        <Accordion.Body>
                        Yes, we have a gift registry. Please visit our registry page for more information on how to contribute to our registry.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="8">
                        <Accordion.Header>Can I bring a plus one or additional guests?</Accordion.Header>
                        <Accordion.Body>
                        To ensure we can accommodate everyone, we kindly request that you RSVP only for the guests that were specified alongside your invitation.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="9">
                        <Accordion.Header>What are some things to do in the area for guests traveling from out of town?</Accordion.Header>
                        <Accordion.Body>
                        In Ludlow there are many things to do, such as visiting Ludlow Castle, walking along the River Teme, and exploring the local shops and restaurants. The surrounding countryside offers beautiful walks and scenic views. We recommend checking out the Ludlow Food Centre for local produce and delicious treats.
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>           
            </Container>
        </div>
    );
}

export default FAQ;